module.exports = __webpack_public_path__ + "img/ifgoiano-vertical-preto.9d25bed9.svg";